import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'techDoc.popUp.title',
        defaultMessage: 'PopUp message'
    },
    NO_MESSAGE: {
        id: 'techDoc.popUp.noMessage',
        defaultMessage: 'No message'
    },
    CONFIRMATION_MESSAGE: {
        id: 'techDoc.popUp.confirmationMessage',
        defaultMessage: 'I RECOGNIZED TO HAVE KNOWN THE MESSAGE ABOVE'
    },
});

export default messages;
